"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInterval = void 0;
var _react = require("react");
/**
 * Hook to call a method on a scheduled setInterval
 *
 * @name useInterval
 * @param {function} callback Function to call after interval
 * @param {number} delay Interval length in milliseconds
 * @returns {object} setInterval object
 */
const useInterval = (callback, delay) => {
  const intervalRef = (0, _react.useRef)(null);
  const savedCallback = (0, _react.useRef)(callback);
  (0, _react.useEffect)(() => {
    savedCallback.current = callback;
  }, [callback]);
  (0, _react.useEffect)(() => {
    const tick = () => savedCallback.current();
    if (typeof delay === "number") {
      intervalRef.current = window.setInterval(tick, delay);
      return () => window.clearInterval(intervalRef.current);
    }
  }, [delay]);
  return intervalRef;
};
exports.useInterval = useInterval;